import webStorage from './storageManager';
// import dayjs from 'dayjs';

const TOKEN_INFO = 'TOKEN_INFO';
const REFRESH_TOKEN = 'REFRESH_TOKEN';
const TOKEN_EXPIRES_TIME = 'TOKEN_EXPIRES_TIME'; // token过期时间YYYYMMDDHHmmss
const TOKEN_REFRESH_TIME = 'TOKEN_REFRESH_TIME'; // token刷新时间YYYYMMDDHHmmss

export const removeToken = () => {
  webStorage.delete(TOKEN_INFO);
  webStorage.delete(REFRESH_TOKEN);
  webStorage.delete(TOKEN_EXPIRES_TIME);
  webStorage.delete(TOKEN_REFRESH_TIME);
};

export const setToken = (tokenData) => {
  console.log({ tokenData });
  setRefreshToken(tokenData.refresh_token);
  const expiresTime = tokenData.expires_in;
  // webStorage.set(TOKEN_INFO, tokenData.access_token, {
  //   exp: expiresTime,
  // });
  webStorage.set(TOKEN_INFO, tokenData.access_token, { exp: expiresTime });
  // webStorage.set(TOKEN_INFO, tokenData.access_token);
  // // 当前时间 + 过期秒数 = token过期时间
  // let nowTime = dayjs();
  // let tokenExpiresTime = nowTime.add(expiresTime, 'second');
  // let tokenRefeshTime = nowTime
  //   .add(expiresTime, 'seconds')
  //   .subtract(expiresTime / 2, 'second');
  // // console.log("setToken -> tokenExpiresTime", tokenExpiresTime.format('YYYYMMDDHHmmss'))
  // // console.log("setToken -> tokenRefeshTime", tokenRefeshTime.format('YYYYMMDDHHmmss'))
  // webStorage.set(
  //   TOKEN_EXPIRES_TIME,
  //   Number(tokenExpiresTime.format('YYYYMMDDHHmmss')),
  // );
  webStorage.set(TOKEN_REFRESH_TIME, 40, { exp: 7000 });
};

export const getToken = () => {
  return webStorage.get(TOKEN_INFO);
};

export const setRefreshToken = (refreshToken) => {
  webStorage.set(REFRESH_TOKEN, refreshToken);
};

export const getRefreshToken = () => {
  return webStorage.get(REFRESH_TOKEN);
};

export const getTokenExpiresTime = () => {
  return webStorage.get(TOKEN_EXPIRES_TIME);
};

export const getTokenRefreshTime = () => {
  return webStorage.get(TOKEN_REFRESH_TIME);
};
